import { default as Alert } from 'antd/es/alert';
import { useEffect } from 'react';

import { padColumns } from 'utils/pad-columns';

import { ErrorBoundary } from '@templates/ErrorBoundary';
import type { CollectionPaymentFindOne } from 'api';
import { useGetCollectionPaymentsFindByUuidOrUniqueReference } from 'api';

import { useOrganisationId } from 'hooks/context';

import { PaymentDetails } from 'components/pages/PaymentDetails';

import { apiParams } from './apiAdapter';
import { getColumns } from './columns';
import { PAYMENTS_SEARCH_RESULT_TEST_ID } from './constants';

import { SearchResults } from '../SearchResults';

type Props = {
  onSuccess: (payment: CollectionPaymentFindOne | undefined) => void;
  searchParams: any;
};

export const PaymentsSearchResults = ({ searchParams, onSuccess }: Props) => {
  const organisationId = useOrganisationId<number>();
  const {
    data: { data: paymentRowData } = {},
    error,
    isFetching,
    isSuccess
  } = useGetCollectionPaymentsFindByUuidOrUniqueReference(
    organisationId,
    apiParams(searchParams)
  );

  useEffect(() => {
    if (!isFetching && isSuccess) {
      onSuccess(paymentRowData);
    }
  }, [isFetching, isSuccess, onSuccess, paymentRowData]);

  const columns = padColumns(getColumns());

  if (paymentRowData && !error) {
    return (
      <SearchResults
        idKey="uuid"
        title="Pay-ins Order Payments"
        data={[paymentRowData]}
        e2eId={PAYMENTS_SEARCH_RESULT_TEST_ID}
        isFetching={isFetching}
        columnsDefinition={columns}
        onRowClick={() => {}}
        detailComponent={
          <ErrorBoundary
            fallback={
              <Alert type="error" message="Failed to show Payment Details" />
            }
          >
            <PaymentDetails />
          </ErrorBoundary>
        }
      />
    );
  }
};
